import { ArrowLeftFilled } from '@fluentui/react-icons';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import Placeholder from '../../components/Placeholder/Placeholder';

export const Route = createFileRoute('/_auth/folder/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return <Placeholder iconText={t('placeholder.iconText')} description={t('placeholder.description')} icon={<ArrowLeftFilled />} />;
}
